import styles from './PointsToRedeem.module.css';
import imgCoin from '../../../../assets/images/coin.png';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import { Card } from '../../../../components/Card';
import { useAuth } from '../../../../hooks/useAuth';
import { usePoints } from '../../../../hooks/usePoints';

export function PointsToRedeem() {
  const { client } = useAuth();
  const { availableToRedeem } = usePoints();

  return (
    <div
      className={`col-sm-12 col-md-6 d-flex pb-3 ${client?.settings?.redemptionPolicy ? 'col-lg-3' : 'col-lg-4'}`}
    >
      <Card
        style={{
          height: '130px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="d-flex align-items-center">
          <img className={`me-3 ${styles.icon}`} src={imgCoin} alt="moeda" />
          <div className="d-block">
            <p className="m-0 tiny-text">Para resgatar</p>
            <p className="m-0 fs-4 fw-semibold">
              {numberWithCommas(availableToRedeem.toFixed(2))}{' '}
              <span className="tiny-text">
                {availableToRedeem === 1 ? (
                  <span>{`${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'ponto'}`}</span>
                ) : (
                  <span>{`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}</span>
                )}
              </span>
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
